import '@main';
import '@vendor/swiper/swiper-bundle.min.js';

u.importCSS('@vendor/swiper/swiper-bundle.min.css');

const locationSwiper = new Swiper('.locationSwiper', {
  navigation: {
    nextEl: ".c-swiper-btn-prev",
    prevEl: ".c-swiper-btn-next",
  },
  pagination: {
    el: '.j-awakening-swiper-pagination'
  },
  loop: true,
  autoplay: true
});

// ticket to theater guidelines
const urlParams = new URLSearchParams(window.location.search);
const tab = urlParams.get('tab');

if (tab === 'visit') {
  const visitTriggerEl = document.querySelector('button[data-bs-target="#visit"]');
  if (visitTriggerEl) {
    const visitTrigger = new bootstrap.Tab(visitTriggerEl);
    visitTrigger.show();

    const visitSection = document.getElementById('boarding');
    if (visitSection) {
      visitSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }
}
